"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Parser = void 0;
var _tsRes = require("ts-res"),
  _kameleoonError = require("../kameleoonError"),
  _types = require("../types"),
  _visitProcessor = require("../kameleoonData/visitProcessor"),
  _constants = require("./constants");
var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
  }
  return _createClass(Parser, null, [{
    key: "parseFeatureVariable",
    value: function parseFeatureVariable(a) {
      var b = a.key,
        c = a.type,
        d = a.value;
      switch (c) {
        case _types.VariableType.BOOLEAN:
          return (0, _tsRes.Ok)({
            key: b,
            type: c,
            value: !!d
          });
        case _types.VariableType.JS:
        case _types.VariableType.CSS:
        case _types.VariableType.STRING:
          return (0, _tsRes.Ok)({
            key: b,
            type: c,
            value: d + ""
          });
        case _types.VariableType.NUMBER:
          var e = +d;
          return Number.isNaN(e) ? (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.NumberParse, d + "")) : (0, _tsRes.Ok)({
            key: b,
            type: c,
            value: e
          });
        case _types.VariableType.JSON:
          try {
            var _d = JSON.parse(a.value + "");
            return (0, _tsRes.Ok)({
              key: b,
              type: c,
              value: _d
            });
          } catch (a) {
            return (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.JSONParse, a));
          }
        default:
          (0, _kameleoonError.exhaustCheck)(c);
      }
    }
  }, {
    key: "parseVisitorData",
    value: function parseVisitorData(a) {
      var b = a.data,
        c = a.filters,
        d = a.visitorCode,
        e = a.dataManager,
        f = a.variationConfiguration;
      var g = new _visitProcessor.VisitProcessor({
          filters: c,
          dataManager: e,
          visitorCode: d
        }),
        h = b.currentVisit,
        i = b.previousVisits,
        j = b.kcs;
      var k = [];
      if (h && k.push(h), i && k.push.apply(k, _toConsumableArray(i)), !k.length) return {
        visitorData: [],
        storageVisitorData: []
      };
      k.forEach(function (a) {
        g.processVisit(a);
      }), g.processKcs(j), g.processMultipleDataTypes();
      var l = g.processMappingIdentifier(null !== h && void 0 !== h ? h : null === i || void 0 === i ? void 0 : i[0]),
        _g$data = g.data,
        m = _g$data.visitorData,
        n = _g$data.storageVisitorData,
        o = _g$data.visitsData,
        p = _g$data.experimentData;
      return f.updateStoredVariations(d, p), {
        visitorData: m,
        storageVisitorData: n,
        visitsData: o,
        mappingIdentifier: l
      };
    }
  }, {
    key: "parseRegExp",
    value: function parseRegExp(a) {
      if ("/" === a[0]) {
        var _a$split = a.split("/"),
          _a$split2 = _slicedToArray(_a$split, 3),
          _ = _a$split2[0],
          b = _a$split2[1],
          c = _a$split2[2];
        return new RegExp(b, c);
      }
      return new RegExp(a);
    }
  }, {
    key: "parseSecret",
    value: function parseSecret(a) {
      if (null === a) return "null";
      var b = a.length;
      if (b <= _constants.SECRET_VISIBLE_LENGTH) return _constants.HIDDEN_SECRET_CHAR.repeat(b);
      var c = Math.max(b - _constants.SECRET_VISIBLE_LENGTH, _constants.SECRET_VISIBLE_LENGTH);
      return a.substring(0, b - c) + _constants.HIDDEN_SECRET_CHAR.repeat(c);
    }
  }]);
}();
exports.Parser = Parser;